module.exports = __webpack_public_path__ + "media/product/i-3-61089123.png";